﻿export type ObjectValues<T> = T[keyof T];

export const SearchContextEnum = {
  Normal: 'normal',
  SuperFavorite: 'superFavorite',
  AddFavorite: 'addFavorite'
} as const;

export type SearchContext = ObjectValues<typeof SearchContextEnum>;

export type FavoriteSessionObject = {
  type: SearchContext,
  id: string;
}

export type Guid = string & { __brand: 'Guid' };

export function isGuid(value: string): value is Guid {
  const guidPattern = /(^[0-9a-fA-F]{8}-[0-9a-fA-F]{4}-[0-9a-fA-F]{4}-[0-9a-fA-F]{4}-[0-9a-fA-F]{12}$)|^[0-9a-fA-F]{32}$/;
  return guidPattern.test(value);
}

export type PotOfGoldProps = {
  isPotOfGold?: boolean;
};

export enum BingoGame {
  id = '182'
}

export type BingoScreenNameForGame = {
  screenName: string,
}